import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const TableDownstreamWorkbooksFilteredByColumnWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query TableDownstreamWorkbooksFilteredByColumnWithoutPersonalSpaceQuery(
  $tableId: ID!,
  $columnId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: WorkbookSortOrder!
) {
  tables(filter: { id: $tableId }) {
    columns(filter: { id: $columnId }) {
      downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          id
          name
          vizportalUrlId
          description
          projectName
          projectVizportalUrlId
          owner {
            name
            username
            domain
          }
          sheetsConnection {
            totalCount
          }
        }
      }
    }
  }
}
`;
